export default __webpack_public_path__ + "static/media/IMG_0926.c7aa62dc.JPG";